export default function SnapshotInfoRow({ label, value }) {
  return (
    <div className={'Snapshot-infoRow'}>
      <p className="Snapshot-infoLabel headingStrong">{label}</p>
      <div className="Snapshot-infoValue">{value}</div>
    </div>
  );
}
